import React from 'react';

function Radio({ facetId, facetItem, onFacetChange }) {
    const { itemId, value, name } = facetItem;

    return (
        <label className="input-label label-span-added" htmlFor={itemId}>
            <input
                id={itemId}
                type="radio"
                name={facetId}
                checked={value}
                onChange={() => onFacetChange(facetId, 'radio', facetItem)}
            />

            <span className="checkbox-radio-visual-el" />

            <div>{name}</div>
        </label>
    );
}

export { Radio };
